import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import './services/i18n';

import App from './app/App';

ReactDOM.render(<BrowserRouter basename="/"><App/></BrowserRouter>, document.getElementById('root'));
